import { createV3Queries } from "@query/utils/createV3Queries";
import { payrollRunsApi } from "@api";

export const queriesPayrollRuns = createV3Queries(
  "payrollRunsApi",
  payrollRunsApi
);
